import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { InvocationStatus } from "../ActionRecord";

const refetchIntervalMs = 5000;

export const useRecentlyCompletedInvocations = (datasetId: string) => {
  const { currentOrganization } = useAuth();
  const { actionService } = useDomainServices();

  return useQuery({
    queryKey: ["recentlyCompletedInvocations", datasetId],
    queryFn: async ({ signal }) => {
      if (currentOrganization === null) {
        return Promise.reject(new Error("CurrentOrganization is not set"));
      }

      const response = await actionService.queryRecentInvocationsForDataset(
        currentOrganization.org_id,
        datasetId,
        signal,
      );

      if (!response) {
        return { items: [] };
      }

      // Filter for invocations that completed within the refetch interval
      const cutoffTime = new Date(Date.now() - refetchIntervalMs);
      const recentlyCompleted = response.items.filter((record) => {
        const lastStatus = record.status[record.status.length - 1];
        return (
          lastStatus.status === InvocationStatus.Completed &&
          new Date(lastStatus.timestamp) > cutoffTime
        );
      });

      return { items: recentlyCompleted };
    },
    refetchInterval: refetchIntervalMs,
    enabled: currentOrganization !== null,
  });
};
